module.exports = __webpack_public_path__ + "static/media/wedding6.d0f6af1a.jpg";